import { render, staticRenderFns } from "./Settingupwidget.vue?vue&type=template&id=4335d228"
import script from "./Settingupwidget.vue?vue&type=script&lang=js"
export * from "./Settingupwidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports